import React from 'react';

interface PreloaderProps {
    deactivate?: boolean;
    message?: string;
    subtext?: string;
}

const Preloader: React.FC<PreloaderProps> = ({ deactivate, message, subtext }) => {
    return (
        <div id="loading" className={deactivate ? 'preloader-deactivate' : ''}>
            <div id="loading-center">
                <div id="loading-center-absolute">
                    <div className="object" id="object_one"></div>
                    <div className="object" id="object_two"></div>
                    <div className="object" id="object_three"></div>
                    <div className="object" id="object_four"></div>
                </div>
                {(message || subtext) && (
                    <div className="loading-content" style={{
                        position: 'absolute',
                        top: '60%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        textAlign: 'center',
                        width: '100%',
                        padding: '0 20px'
                    }}>
                        {message && <h2 style={{
                            fontSize: '20px',
                            color: '#196565',
                            fontWeight: '600',
                            margin: '0 0 8px 0',
                            textTransform: 'uppercase',
                            letterSpacing: '1px'
                        }}>{message}</h2>}
                        {subtext && <p style={{
                            fontSize: '14px',
                            color: '#616161',
                            margin: '0'
                        }}>{subtext}</p>}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Preloader;
